import { definePreset } from "@primeng/themes";
import Lara from "@primeng/themes/lara";

export const MyPreset = definePreset(Lara, {
  primitive: {
    borderRadius: {
      none: "0",
      xs: "2px",
      sm: "4px",
      md: "6px",
      lg: "8px",
      xl: "12px",
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22",
    },
    green: {
      '50': '#f3f9ec',
      '100': '#e5f2d5',
      '200': '#cce6b0',
      '300': '#aad581',
      '400': '#8bc259',
      '500': '#689f38',
      '600': '#54852b',
      '700': '#416625',
      '800': '#365222',
      '900': '#304621',
      '950': '#17260d',
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05",
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a",
    },
    orange: {
      "50": "#fffbeb",
      "100": "#fdf3c8",
      "200": "#fce58b",
      "300": "#fad24f",
      "400": "#f9c02e",
      "500": "#f39d0d", //default
      "600": "#d77708", //hover
      "700": "#b2530b",
      "800": "#91400f",
      "900": "#773510",
      "950": "#441a04",
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03",
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006",
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e",
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344",
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49",
    },
    blue: {
      '50': '#eefaff',
      '100': '#daf3ff',
      '200': '#bdebff',
      '300': '#8fe0ff',
      '400': '#5accff',
      '500': '#34b1fd',
      '600': '#2196f3',
      '700': '#167bdf',
      '800': '#1863b5',
      '900': '#1a548e',
      '950': '#153456',
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b",
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065",
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764",
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e",
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724",
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519",
    },
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617",
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712",
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b",
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a",
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09",
    },
  },
  semantic: {
    primary: {
      50: "#f5f4fa",
      100: "#cdc9e9",
      200: "#a69dd7",
      300: "#7f72c6",
      400: "#5747b4",
      500: "#301ca3",
      600: "#29188b",
      700: "#221472",
      800: "#1a0f5a",
      900: "#130b41",
      950: "#0c0729",
    },
    colorScheme: {
      light: {
        surface: {
          0: "#ffffff", 
          50: "#fafafa", 
          100: "#f5f5f5", 
          200: "#e5e5e5", 
          300: "#d4d4d4", 
          400: "#a1a1a1", 
          500: "#737373", 
          600: "#525252", 
          700: "#404040", 
          800: "#262626", 
          900: "#171717", 
          950: "#0a0a0a", 
        },
        primary: {
          color: "{primary.500}",
          contrastColor: "#ffffff",
          hoverColor: "{primary.600}",
          activeColor: "{primary.700}",
        },
        highlight: {
          background: "{primary.50}",
          focusBackground: "{primary.100}",
          color: "{primary.700}",
          focusColor: "{primary.800}",
        },
        mask: {
          background: "rgba(0,0,0,0.4)",
          color: "{surface.200}",
        },
        formField: {
          background: "{surface.0}",
          disabledBackground: "{surface.200}",
          filledBackground: "{surface.50}",
          filledHoverBackground: "{surface.50}",
          filledFocusBackground: "{surface.50}",
          borderColor: "{surface.300}",
          hoverBorderColor: "{surface.400}",
          focusBorderColor: "{primary.color}",
          invalidBorderColor: "{red.400}",
          color: "{surface.700}",
          disabledColor: "{surface.500}",
          placeholderColor: "{surface.500}",
          invalidPlaceholderColor: "{red.600}",
          floatLabelColor: "{surface.500}",
          floatLabelFocusColor: "{primary.600}",
          floatLabelActiveColor: "{surface.500}",
          floatLabelInvalidColor: "{form.field.invalid.placeholder.color}",
          iconColor: "{surface.400}",
          shadow: "0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(18, 18, 23, 0.05)",
        },
        text: {
          color: "{surface.700}",
          hoverColor: "{surface.800}",
          mutedColor: "{surface.500}",
          hoverMutedColor: "{surface.600}",
        },
        content: {
          background: "{surface.0}",
          hoverBackground: "{surface.100}",
          borderColor: "{surface.200}",
          color: "{text.color}",
          hoverColor: "{text.hover.color}",
        },
        overlay: {
          select: {
            background: "{surface.0}",
            borderColor: "{surface.200}",
            color: "{text.color}",
          },
          popover: {
            background: "{surface.0}",
            borderColor: "{surface.200}",
            color: "{text.color}",
          },
          modal: {
            background: "{surface.0}",
            borderColor: "{surface.200}",
            color: "{text.color}",
          },
        },
        list: {
          option: {
            focusBackground: "{surface.100}",
            selectedBackground: "{highlight.background}",
            selectedFocusBackground: "{highlight.focus.background}",
            color: "{text.color}",
            focusColor: "{text.hover.color}",
            selectedColor: "{highlight.color}",
            selectedFocusColor: "{highlight.focus.color}",
            icon: {
              color: "{surface.400}",
              focusColor: "{surface.500}",
            },
          },
          optionGroup: {
            background: "transparent",
            color: "{text.muted.color}",
          },
        },
        navigation: {
          item: {
            focusBackground: "{surface.100}",
            activeBackground: "{surface.100}",
            color: "{text.color}",
            focusColor: "{text.hover.color}",
            activeColor: "{text.hover.color}",
            icon: {
              color: "{surface.400}",
              focusColor: "{surface.500}",
              activeColor: "{surface.500}",
            },
          },
          submenuLabel: {
            background: "transparent",
            color: "{text.muted.color}",
          },
          submenuIcon: {
            color: "{surface.400}",
            focusColor: "{surface.500}",
            activeColor: "{surface.500}",
          },
        },
      },
      dark: {
        surface: {
          0: "#101010", 
          50: "#1a1a1a", 
          100: "#222222", 
          200: "#2a2a2a", 
          300: "#202020", 
          400: "#303030", 
          500: "#505050", 
          600: "#707070", 
          700: "#909090", 
          800: "#b0b0b0", 
          900: "#d0d0d0", 
          950: "#f0f0f0", 
        },
        primary: {
          color: "{primary.700}",
          contrastColor: "{surface.900}",
          hoverColor: "{primary.500}",
          activeColor: "{primary.400}",
        },
        highlight: {
          background: "color-mix(in srgb, {primary.400}, transparent 84%)",
          focusBackground: "color-mix(in srgb, {primary.400}, transparent 76%)",
          color: "rgba(255,255,255,.87)",
          focusColor: "rgba(255,255,255,.87)",
        },
        mask: {
          background: "rgba(0,0,0,0.6)",
          color: "{surface.200}",
        },
        formField: {
          background: "{surface.950}",
          disabledBackground: "{surface.700}",
          filledBackground: "{surface.800}",
          filledHoverBackground: "{surface.800}",
          filledFocusBackground: "{surface.800}",
          borderColor: "{surface.600}",
          hoverBorderColor: "{surface.500}",
          focusBorderColor: "{primary.color}",
          invalidBorderColor: "{red.300}",
          color: "{surface.0}",
          disabledColor: "{surface.400}",
          placeholderColor: "{surface.400}",
          invalidPlaceholderColor: "{red.400}",
          floatLabelColor: "{surface.400}",
          floatLabelFocusColor: "{primary.color}",
          floatLabelActiveColor: "{surface.400}",
          floatLabelInvalidColor: "{form.field.invalid.placeholder.color}",
          iconColor: "{surface.400}",
          shadow: "0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(18, 18, 23, 0.05)",
        },
        text: {
          color: "{surface.0}",
          hoverColor: "{surface.0}",
          mutedColor: "{surface.400}",
          hoverMutedColor: "{surface.300}",
        },
        content: {
          background: "{surface.300}",
          hoverBackground: "{surface.800}",
          borderColor: "{surface.400}",
          color: "{text.color}",
          hoverColor: "{text.hover.color}",
        },
        overlay: {
          select: {
            background: "{surface.900}",
            borderColor: "{surface.700}",
            color: "{text.color}",
          },
          popover: {
            background: "{surface.900}",
            borderColor: "{surface.700}",
            color: "{text.color}",
          },
          modal: {
            background: "{surface.900}",
            borderColor: "{surface.700}",
            color: "{text.color}",
          },
        },
        list: {
          option: {
            focusBackground: "{surface.800}",
            selectedBackground: "{highlight.background}",
            selectedFocusBackground: "{highlight.focus.background}",
            color: "{text.color}",
            focusColor: "{text.hover.color}",
            selectedColor: "{highlight.color}",
            selectedFocusColor: "{highlight.focus.color}",
            icon: {
              color: "{surface.500}",
              focusColor: "{surface.400}",
            },
          },
          optionGroup: {
            background: "transparent",
            color: "{text.muted.color}",
          },
        },
        navigation: {
          item: {
            focusBackground: "{surface.800}",
            activeBackground: "{surface.800}",
            color: "{text.color}",
            focusColor: "{text.hover.color}",
            activeColor: "{text.hover.color}",
            icon: {
              color: "{surface.500}",
              focusColor: "{surface.400}",
              activeColor: "{surface.400}",
            },
          },
          submenuLabel: {
            background: "transparent",
            color: "{text.muted.color}",
          },
          submenuIcon: {
            color: "{surface.500}",
            focusColor: "{surface.700}",
            activeColor: "{surface.400}",
          },
        },
      },
    },
  },
  components: {
    tag: {
      font: {
        size: "12px",
        weight: "500",
      },
      colorScheme: {
        light: {
          secondary: {
            background: "{surface.300}",
            color: "{surface.900}",
          },
          success: {
            background: "{green.700}",
            color: "{surface.0}",
          },
          info: {
            background: "{sky.700}",
            color: "{surface.0}",
          },
          warn: {
            background: "{orange.700}",
            color: "{surface.0}",
          },
          danger: {
            background: "{red.700}",
            color: "{surface.0}",
          },
        },
        dark: {
          secondary: {
            background: "{surface.400}",
            color: "{surface.950}",
          },
          success: {
            background: "{green.800}",
            color: "{green.50}",
          },
          info: {
            background: "{sky.800}",
            color: "{sky.50}",
          },
          warn: {
            background: "{orange.800}",
            color: "{orange.50}",
          },
          danger: {
            background: "{red.800}",
            color: "{red.50}",
          },
        },
      },
    },
    badge: {
      colorScheme: {
        light: {
          secondary: {
            background: "{surface.300}",
            color: "{surface.900}",
          },
          success: {
            background: "{green.700}",
            color: "{surface.0}",
          },
          info: {
            background: "{sky.700}",
            color: "{surface.0}",
          },
          warn: {
            background: "{orange.700}",
            color: "{surface.0}",
          },
          danger: {
            background: "{red.700}",
            color: "{surface.0}",
          },
        },
        dark: {
          secondary: {
            background: "{surface.400}",
            color: "{surface.950}",
          },
          success: {
            background: "{green.800}",
            color: "{green.50}",
          },
          info: {
            background: "{sky.800}",
            color: "{sky.50}",
          },
          warn: {
            background: "{orange.800}",
            color: "{orange.50}",
          },
          danger: {
            background: "{red.800}",
            color: "{red.50}",
          },
        },
      },
    },
    chip: {
      colorScheme: {
        light: {
          root: {
            background: "{surface.300}",
            color: "{surface.900}",
          },
          icon: {
            color: "{surface.900}",
          },
          removeIcon: {
            color: "{surface.900}",
          },
        },
        dark: {
          root: {
            background: "{surface.400}",
            color: "{surface.950}",
          },
          icon: {
            color: "{surface.950}",
          },
          removeIcon: {
            color: "{surface.950}",
          },
        },
      },
    },
    message: {
      colorScheme: {
        light: {
          info: {
            background: "{blue.300}",
            borderColor: "{blue.600}",
            color: "{blue.950}",
          },
          success: {
            background: "{green.300}",
            borderColor: "{green.700}",
            color: "{green.950}",
          },
          warn: {
            background: "{orange.300}",
            borderColor: "{orange.700}",
            color: "{orange.950}",
          },
          error: {
            background: "{red.300}",
            borderColor: "{red.700}",
            color: "{red.950}",
          },
          secondary: {
            background: "{surface.300}",
            borderColor: "{surface.500}",
            color: "{surface.900}",
          },
        },
        dark: {
          info: {
            background: "{blue.800}",
            borderColor: "{blue.600}",
            color: "{blue.50}",
          },
          success: {
            background: "{green.800}",
            borderColor: "{green.600}",
            color: "{green.50}",
          },
          warn: {
            background: "{orange.800}",
            borderColor: "{orange.600}",
            color: "{orange.50}",
          },
          error: {
            background: "{red.800}",
            borderColor: "{red.600}",
            color: "{red.50}",
          },
          secondary: {
            background: "{surface.400}",
            borderColor: "{surface.600}",
            color: "{surface.950}",
          },
        },
      },
    },
    inlinemessage: {
      colorScheme: {
        light: {
          info: {
            background: "{blue.300}",
            borderColor: "{blue.600}",
            color: "{blue.950}",
          },
          success: {
            background: "{green.300}",
            borderColor: "{green.700}",
            color: "{green.950}",
          },
          warn: {
            background: "{orange.300}",
            borderColor: "{orange.700}",
            color: "{orange.950}",
          },
          error: {
            background: "{red.300}",
            borderColor: "{red.700}",
            color: "{red.950}",
          },
          secondary: {
            background: "{surface.300}",
            borderColor: "{surface.500}",
            color: "{surface.900}",
          },
        },
        dark: {
          info: {
            background: "{blue.800}",
            borderColor: "{blue.600}",
            color: "{blue.50}",
          },
          success: {
            background: "{green.800}",
            borderColor: "{green.600}",
            color: "{green.50}",
          },
          warn: {
            background: "{orange.800}",
            borderColor: "{orange.600}",
            color: "{orange.50}",
          },
          error: {
            background: "{red.800}",
            borderColor: "{red.600}",
            color: "{red.50}",
          },
          secondary: {
            background: "{surface.400}",
            borderColor: "{surface.600}",
            color: "{surface.950}",
          },
        },
      },
    },
    carousel: {
      indicator: {
        borderRadius: "15px",
        height: "8px",
        width: "32px",
      },
      colorScheme: {
        light: {
          indicator: {
            activeBackground: "{orange.500}",
          },
        },
        dark: {
          indicator: {
            activeBackground: "{orange.500}",
          },
        },
      },
    },
    popover:{
      colorScheme: {
        dark: {
          background: "{surface.200}",
          color: "{surface.950}"
        },
      },
    },
    button: {
      colorScheme: {
        light: {
          secondary: {
            background: "{pink.500}",
            color: "{surface.50}",
            hover: {
              background: "{pink.400}",
              color: "{surface.50}",
            },
          },
          info: {
            hover: {
              background: "{sky.400}",
              border: {
                color: "{surface.50}",
              },
            },
          },
          sucess: {
            hover: {
              backgorund: "{primary.300}",
            },
          },
        },
        dark: {
          success: {
            background: "{green.500}",
            color: "{surface.950}",
            border: {
              color: "{green.500}",
            },
            hover: {
              background: "{green.600}",
              color: "{surface.950}",
            },
          },
          secondary: {
            background: "{pink.500}",
            color: "{surface.950}",
            border: {
              color: "{pink.500}",
            },
            hover: {
              background: "{pink.600}",
              color: "{surface.950}",
            },
          },
          info: {
            background: "{cyan.500}",
            color: "{surface.950}",
            border: {
              color: "{cyan.500}",
            },
            hover: {
              background: "{cyan.600}",
              color: "{surface.950}",
              
            },
          },
          danger: {
            background: "{red.500}",
            color: "{surface.950}",
            border: {
              color: "{red.500}",
            },
            hover: {
              background: "{red.600}",
              color: "{surface.950}",
            },
          },
          warn: {
            background: "{orange.500}",
            color: "{surface.950}",
            border: {
              color: "{orange.500}",
            },
            hover: {
              background: "{orange.600}",
              color: "{surface.950}",
            },
          },
          outlined: {
            primary: {
              color: "{surface.950}",
              border: {
                color: "{surface.600}",
              },
            },
          },
          text: {
            primary: {
              color: "{surface.950}",
            },
            secondary: {
              color: "{surface.950}",
            },
          },
        },
      },
      label: {
        font: {
          weight: "400",
        }
      },
    },
    accordion:{
      colorScheme: {
        dark: {
          header: {
            background:{
              background:"{surface.300}"
            },
            hover:{
              background:"{surface.400}",
              color:"{surface.950}"
            },
            active:{
              background:"{surface.400}",
              color:"{surface.950}"
            },
            color:"{surface.950}"
            // toggle:{
            //   icon:{
            //     color:"{surface.950}",
            //     hover:{
            //       color:{
            //         color:"{surface.50}"
            //       }
            //     }
            //   }
            // }
          },
        },
      },
    },
    panelmenu: {
      colorScheme: {
        light: {
          item: {
            focus: {
              color: "#301da2",
            },
            color: "#301da2",
            focusBackground: "{surface.200}",
          },
        },
        dark: {
          item: {
            focusBackground: "{surface.200}",
            activeBackground: "{surface.500}",
            focus: {
              color: "{surface.950}",
              background: "{surface.200}",
            },
            color: "{surface.950}",
            icon: {
              color: "{surface.950}",
              focus: {
                color: "{surface.700}",
              },
            },
            submenu: {
              icon: {
                focus: {
                  color: "{surface.500}",
                },
              },
            },
          },
        },
      },
    },
    iconfield: {
      colorScheme: {
        dark: {
          icon: {
            color: "{surface.800}",
          },
        },
      },
    },
    datatable: {
      colorScheme: {
        dark: {
          row: {
            color: "{surface.900}",
          },
          header: {
            background: "{surface.300}",
            color: "{surface.900}",
          },
          headerCell: {
            background: "{surface.300}",
            color: "{surface.900}",
          },
        },
        light: {
          headerCell: {
            background: "{surface.100}",
            borderColor: "{surface.800}",
          },
        },
      },
    },
    paginator: {
      colorScheme: {
        dark: {
          current: {
            page: {
              report: {
                color: "{surface.950}",
              },
            },
          },
          nav: {
            button: {
              color: "{surface.950}",
            },
          },
        },
      },
    },
    inputtext: {
      colorScheme: {
        light: {},
        dark: {
          background: "{surface.400}",
          color: "{surface.950}",
          placeholder: {
            color: "{surface.950}",
          },
        },
      },
    },
    select: {
      colorScheme: {
        dark: {
          background: "{surface.400}",
          color: "{surface.950}",
          overlay: {
            background: "{surface.100}",
            color: "{surface.950}",
          },
          option: {
            color: "{surface.950}",
            focus: {
              background: "{surface.400}",
              color: "{surface.950}",
            },
          },
          disabled: {
            background: "{surface.400}",
            color: "{surface.950}",
          },
          clear: {
            icon: {
              color: "{surface.950}",
            },
          },
          dropdown: {
            color: "{surface.950}",
          },
          placeholder: {
            color: "{surface.950}",
          },
        },
        light: {
          disabled: {
            background: "{surface.50}",
            color: "{surface.950}",
          },
        },
      },
    },
    tieredmenu: {
      item: {
        icon: {
          color: "{surface.950}",
        },
      },
    },
    drawer: {
      colorScheme: {
        dark: {
          background: "{surface.300}",
          color: "{surface.950}",
        },
      },
    },
    togglebutton: {
      colorScheme: {
        dark: {
          background: "{surface.400}",
          color: "{surface.950}",
        },
      },
    },
    chart: {
      colorScheme: {},
    },
    checkbox: {
      colorScheme: {
        dark: {
          background: "{surface.500}",
        },
      },
    },
    textarea: {
      colorScheme: {
        dark: {
          background: "{surface.400}",
          color: "{surface.950}",
        },
      },
    },
    tabs: {
      colorScheme: {
        dark: {
          tabpanel: {
            background: "{surface.300}",
          },
          tab: {
            background: "{surface.300}",
            color: "{surface.950}",
            active: {
              background: "{surface.200}",
              color: "{surface.950}",
              borderColor: "{surface.950}",
            },
            hover: {
              background: "{surface.400}",
              color: "{surface.950}",
            },
          },
        },
      },
      active: {
        bar: {
          bottom: {},
        },
      },
    },
    panel: {
      colorScheme: {
        dark: {
          header: {
            color: "{surface.950}",
          },
          color: "{surface.950}",
        },
      },
    },
    dialog: {
      colorScheme: {
        dark: {
          background: "{surface.100}",
          color: "{surface.950}",
        },
      },
    },
    listbox: {
      colorScheme: {
        dark: {
          background: "{surface.400}",
          color: "{surface.950}",
          option: {
            color: "{surface.950}",
            focus: {
              background: "{surface.500}",
              color: "{surface.950}",
            },
            selected: {
              background: "{#ccc8e9}",
            },
          },
        },
      },
    },
    multiselect: {
      colorScheme: {
        dark: {
          background: "{surface.300}",
          color: "{surface.950}",
          overlay: {
            background: "{surface.300}",
            color: "{surface.950}",
          },
          option: {
            color: "{surface.950}",
          },
          placeholder:{
            color:"{surface.950}"
          }
        },
      },
    },
    toast: {
      colorScheme: {
        light: {
          info: {
            background: "{blue.300}",
            borderColor: "{blue.600}",
            color: "{blue.950}",
            detailColor: "{blue.950}",
          },
          success: {
            background: "{green.300}",
            borderColor: "{green.700}",
            color: "{green.950}",
            detailColor: "{green.950}",
          },
          warn: {
            background: "{orange.300}",
            borderColor: "{orange.700}",
            color: "{orange.950}",
            detailColor: "{orange.950}",
          },
          error: {
            background: "{red.300}",
            borderColor: "{red.700}",
            color: "{red.950}",
            detailColor: "{red.950}",
          },
          secondary: {
            background: "{surface.300}",
            borderColor: "{surface.500}",
            color: "{surface.900}",
            detailColor: "{surface.800}",
          },
        },
        dark: {
          success: {
            background: "{green.800}",
            color: "{surface.950}",
            detail: {
              color: "{surface.950}",
            },
          },
          warn: {
            background: "{yellow.600}",
            color: "{surface.950}",
            detail: {
              color: "{surface.950}",
            },
          },
          error: {
            background: "{red.800}",
            color: "{surface.950}",
            detail: {
              color: "{surface.950}",
            },
          },
          info: {
            background: "{blue.600}",
            color: "{surface.950}",
            detail: {
              color: "{surface.950}",
            },
          },
        },
      },
    },
    confirmdialog: {
      iconColor: "{surface.950}",
    },
    inputgroup:{
            colorScheme:{
                dark:{
                    addon:{
                        background:"{surface.500}",
                        color:"{surface.950}"
                    }
                }
            }
        },
        datepicker:{
            colorScheme:{
                dark:{
                    dropdown:{
                        background:"{surface.500}",
                        color:"{surface.950}"
                    },
                    panel:{
                        color:"{surface.950}"
                    },
                    header:{
                        color:"{surface.950}"
                    },
                    date:{
                        color:"{surface.950}"
                    },
                    week:{
                        day:{
                            color:"{surface.950}"
                        }
                    },
                    select:{
                        year:{
                            color:"{surface.950}"
                        },
                        month:{
                            color:"{surface.950}"
                        }
                    }
                }
            }
        },
        fileupload:{
            colorScheme:{
                dark:{
                    header:{
                        background:"{surface.300}"
                    },
                    color:"{surface.950}"
                }
            }
        },
        radiobutton:{
            colorScheme:{
                dark:{
                    background:"{surface.500}",
                    border:{
                        color:"{surface.50}"
                    },
                    checked:{
                        background:"{surface.500}",
                    },
                    focus:{
                        background:"{surface.500}",
                    },
                    icon:{
                      size:"0.75rem"
                    }
                }
            }
        }
  },
});
